import React, { SVGProps } from 'react';

export const OpenedBookSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_4878_9920)'>
      <path
        d='M8.0001 3.93817C6.23117 2.8538 4.21543 2.23732 2.14256 2.14674C2.10488 2.14513 2.06727 2.15113 2.03195 2.16438C1.99664 2.17762 1.96435 2.19783 1.93702 2.22382C1.90975 2.24955 1.88799 2.28056 1.87305 2.31495C1.85811 2.34934 1.8503 2.3864 1.8501 2.4239V11.5762C1.85017 11.6483 1.87807 11.7176 1.92797 11.7696C1.97787 11.8217 2.04593 11.8524 2.11796 11.8555C3.05746 11.7217 4.0142 11.7765 4.93227 12.0167C5.85035 12.2569 6.71133 12.6777 7.46491 13.2545C7.6342 13.3246 7.81869 13.35 8.00064 13.3283'
        stroke='currentColor'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.00006 3.93817C9.76899 2.8538 11.7847 2.23732 13.8576 2.14674C13.8953 2.14513 13.9329 2.15113 13.9682 2.16438C14.0035 2.17762 14.0358 2.19783 14.0631 2.22382C14.0906 2.24974 14.1125 2.28101 14.1274 2.3157C14.1424 2.35039 14.1501 2.38777 14.1501 2.42554V11.5762C14.15 11.6483 14.1221 11.7176 14.0722 11.7696C14.0223 11.8217 13.9542 11.8524 13.8822 11.8555C12.9427 11.7217 11.986 11.7765 11.0679 12.0167C10.1498 12.2569 9.28882 12.6777 8.53524 13.2545C8.36595 13.3246 8.18146 13.35 7.99951 13.3283'
        stroke='currentColor'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 3.93848V13.334'
        stroke='currentColor'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.66992 11.8125V13.576C2.66981 13.618 2.67914 13.6594 2.69723 13.6972C2.71532 13.7351 2.7417 13.7684 2.77442 13.7946C2.80714 13.8209 2.84535 13.8395 2.88622 13.8489C2.92709 13.8584 2.96956 13.8585 3.0105 13.8493C4.65159 13.5071 6.32353 13.3346 7.99992 13.3344C9.57775 13.3336 11.1509 13.5053 12.6914 13.8466C12.7323 13.8556 12.7747 13.8553 12.8155 13.8457C12.8563 13.8362 12.8944 13.8176 12.9271 13.7914C12.9597 13.7652 12.9861 13.732 13.0043 13.6942C13.0224 13.6565 13.0319 13.6152 13.032 13.5733V11.8037'
        stroke='currentColor'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_4878_9920'>
        <rect width='14' height='14' fill='white' transform='translate(1 1)' />
      </clipPath>
    </defs>
  </svg>
);
